import React, { useEffect, useState } from "react";
import styles from "./HelpModal.module.scss";
import ArrowLeft from "../../../../assets/arrow-left.svg";
import { useGlobalContext } from "../../../../scanview/ScanViewerContext";
import { getBrowserHelperVideo } from "../../../../scanview/helper";
import { isMobile } from "react-device-detect";
import { useScanVideoContext } from "../../../../scanview/contexts/ScanVideoContext";
import { getBrowserName } from "../../../../utils/getInfoFunctions";
import Instructions from "./Instructions";

export type HelpModalConfig = {
  title?: string;
  text?: string;
  instructionsText?: string;
  retryButtonText?: string;
};

type helpModalTexts = {
  title: string;
  text: string;
  instructionsText: string;
  retryButtonText: string;
};

const HelpModal = () => {
  const { cameraPermissionState, retryCamera } = useScanVideoContext();
  const { webToMobileHandoffConfig, helpModalConfig, setShowErrorModal } =
    useGlobalContext();
  const [helpModalTexts, setHelpModalTexts] = useState<helpModalTexts>({
    title: "Set Up Camera",
    text: "To scan your card, please allow camera access. If the permission prompt doesn’t appear, try refreshing the page.",
    instructionsText: "",
    retryButtonText: "Retry Camera Access",
  });

  const goBack = () => {
    if (webToMobileHandoffConfig?.enabled === true) {
      setShowErrorModal((prev) => ({ ...prev, modal: "cameraPermission" }));
    }
  };

  useEffect(() => {
    const texts = {
      ...(helpModalConfig?.title ? { title: helpModalConfig.title } : {}),
      ...(helpModalConfig?.text ? { text: helpModalConfig.text } : {}),
      ...(helpModalConfig?.retryButtonText
        ? { retryButtonText: helpModalConfig.retryButtonText }
        : {}),
      ...(helpModalConfig?.instructionsText
        ? { instructionsText: helpModalConfig.instructionsText }
        : {}),
    };

    if (Object.keys(texts).length) {
      setHelpModalTexts((prev) => ({
        ...prev,
        ...texts,
      }));
    }
  }, [helpModalConfig]);

  return (
    <div
      className={`${styles.helpModalMainContainer} ${
        isMobile ? styles.mobileView : ""
      }`}
    >
      {webToMobileHandoffConfig?.enabled === true && !isMobile && (
        <button className={styles.goBackBtn} onClick={goBack} role="button">
          <img src={ArrowLeft} alt="Blue arrow pointing to the left" /> Back
        </button>
      )}
      <h2 className={styles.modalTitle}>{helpModalTexts.title}</h2>
      <p className={styles.modalText}>{helpModalTexts.text}</p>
      <div className={styles.videoContainer}>
        <video controls autoPlay loop muted>
          <source
            src={getBrowserHelperVideo(getBrowserName(), isMobile)}
            type="video/mp4"
          />
          Sorry, your browser doesn&apos;t support embedded videos.
        </video>
      </div>
      <div className={styles.instructionsContainer}>
        {helpModalTexts.instructionsText ? (
          <p className={styles.instructionsText}>
            {helpModalTexts.instructionsText}
          </p>
        ) : (
          <Instructions />
        )}
      </div>
      {cameraPermissionState !== "hardblock" && (
        <button className={styles.settingsBtn} onClick={retryCamera}>
          {helpModalTexts.retryButtonText}
        </button>
      )}
    </div>
  );
};

export default HelpModal;
